module.exports = __webpack_public_path__ + "static/media/small-repeat.07de4d46.png";